import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { YouTubePlayerModule } from "@angular/youtube-player";

import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModules } from "../directives/directives.module";

import { BackBtnComponent } from './back-btn/back-btn.component';
import { BoardDetailComponent } from "./board-detail/board-detail.component";
import { CommonPopupsComponent } from './common-popups/common-popups.component';
import { DialectDetailComponent } from "./dialect-detail/dialect-detail.component";
import { DialectItemComponent } from './dialect-item/dialect-item.component';
import { DialectMapBtnComponent } from './dialect-map-popup/dialect-map-btn.component';
import { DialectMapPopupComponent } from './dialect-map-popup/dialect-map-popup.component';
import { DialectWordPlayBtnComponent } from "./word-play-btn/dialect-word-play-btn.component";
import { FooterComponent } from './footer/footer.component';
import { HeaderBookmarkMenuComponent } from './header/header-bookmark-menu.component';
import { HeaderComponent } from './header/header.component';
import { HomonymAllPlayBtnComponent } from "./word-play-btn/homonym-all-play-btn.component";
import { HomonymWordPlayBtnComponent } from "./word-play-btn/homonym-word-play-btn.component";
import { JasoIndexComponent } from './jaso-index/jaso-index.component';
import { JasoIndexDialectComponent } from './jaso-index/jaso-index-dialect.component';
import { JasoIndexSeungjoComponent } from './jaso-index/jaso-index-seungjo.component';
import { LinkContentComponent } from './link-content/link-content.component';
import { LinkExampleComponent } from './link-example/link-example.component';
import { LinkExamplePopupComponent } from './link-example-popup/link-example-popup.component';
import { LinkPopupComponent } from './link-popup/link-popup.component';
import { MsgPopupComponent } from "./common-popups/msg-popup.component";
import { NaverLoginPopupComponent } from "./common-popups/naver-login-popup.component";
import { OptionItemComponent } from './option-item/option-item.component';
import { PitchHelpBtnComponent } from "./pitch-help-popup/pitch-help-btn.component";
import { PitchHelpPopupComponent } from './pitch-help-popup/pitch-help-popup.component';
import { PitchPopupComponent } from "./pitch-popup/pitch-popup.component";
import { ProverbDetailComponent } from "./proverb-detail/proverb-detail.component";
import { SearchBoxComponent } from './search-box/search-box.component';
import { SearchBoxDialectComponent } from './search-box/search-box-dialect.component';
import { SearchBoxSaseungComponent } from './search-box/search-box-saseung.component';
import { VideoBoxComponent } from './video-item/video-box.component';
import { VideoItemComponent } from './video-item/video-item.component';
import { VideoTotalItemComponent } from "./video-item/video-total-item.component";
import { WavGraphComponent } from "./pitch-popup/wav-graph.component";
import { WordDetailComponent } from "./word-detail/word-detail.component";
import { WordDetailHomonymComponent } from "./word-detail/word-detail-homonym.component";
import { WordDetailProverbComponent } from "./word-detail/word-detail-proverb.component";
import { WordDispComponent } from './word-disp/word-disp.component';
import { ExamplePlayBtnComponent } from "./word-play-btn/example-play-btn.component";
import { WordExPlayBtnComponent } from "./word-play-btn/word-ex-play-btn.component";
import { WordHelpBtnComponent } from "./word-help-popup/word-help-btn";
import { WordHelpPopupComponent } from "./word-help-popup/word-help-popup.component";
import { WordHomonymPlayBtnComponent } from "./word-play-btn/word-homonym-play-btn.component";
import { ExampleDetailComponent } from './example-detail/example-detail.component';
import { ExampleListItemComponent } from './example-list-item/example-list-item.component';
import { WordListItemComponent } from './word-list-item/word-list-item.component';
import { WordPlayBtnComponent } from "./word-play-btn/word-play-btn.component";
import { WordRecordBtnComponent } from "./word-record-btn/word-record-btn.component";
import { YoutubePlayerComponent } from './youtube-player/youtube-player.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { LinkPopupItemWordComponent } from './link-popup/link-popup-item-word.component';
import { LinkPopupItemDialectComponent } from './link-popup/link-popup-item-dialect.component';
import { HunPopupComponent } from './hun-popup/hun-popup.component';
import { HunContentComponent } from './hun-content/hun-content.component';
import { WordExampleBtnComponent } from './word-example-btn/word-example-btn.component';
import { ExamplePopupComponent } from './example-popup/example-popup.component';
import { ExampleDispComponent } from './example-disp/example-disp.component';
import { WordHanjaPopupComponent } from './word-hanja-popup/word-hanja-popup.component';
import { HanjaCharComponent } from './word-disp/hanja-char.component';
import { HanjaWordPopupComponent } from './hanja-word-popup/hanja-word-popup.component';
import { HanjaContentComponent } from "./hanja-content/hanja-content.component";
import { ExampleCatIndexComponent } from './example-cat-index/example-cat-index.component';
import { ExampleHelpBtnComponent } from './example-help-popup/example-help-btn';
import { ExampleHelpPopupComponent } from './example-help-popup/example-help-popup.component';


@NgModule({
  declarations: [
    BackBtnComponent,
    BoardDetailComponent,
    ExampleCatIndexComponent,
    CommonPopupsComponent,
    DialectDetailComponent,
    DialectItemComponent,
    DialectMapBtnComponent,
    DialectMapPopupComponent,
    DialectWordPlayBtnComponent,
    FooterComponent,
    HeaderBookmarkMenuComponent,
    HeaderComponent,
    HomonymAllPlayBtnComponent,
    HomonymWordPlayBtnComponent,
    HunPopupComponent,
    HunContentComponent,
    JasoIndexComponent,
    JasoIndexDialectComponent,
    JasoIndexSeungjoComponent,
    LinkContentComponent,
    LinkExampleComponent,
    LinkExamplePopupComponent,
    LinkPopupComponent,
    LinkPopupItemWordComponent,
    LinkPopupItemDialectComponent,
    MsgPopupComponent,
    NaverLoginPopupComponent,
    OptionItemComponent,
    PitchHelpBtnComponent,
    PitchHelpPopupComponent,
    PitchPopupComponent,
    ProverbDetailComponent,
    SearchBoxComponent,
    SearchBoxDialectComponent,
    SearchBoxSaseungComponent,
    VideoBoxComponent,
    VideoItemComponent,
    VideoTotalItemComponent,
    WavGraphComponent,
    WordDetailComponent,
    WordDetailHomonymComponent,
    WordDetailProverbComponent,
    WordDispComponent,
    ExamplePlayBtnComponent,
    WordExPlayBtnComponent,
    WordHelpBtnComponent,
    WordHelpPopupComponent,
    ExampleHelpBtnComponent,
    ExampleHelpPopupComponent,
    WordHomonymPlayBtnComponent,
    ExampleDetailComponent,
    ExampleListItemComponent,
    WordListItemComponent,
    WordPlayBtnComponent,
    WordRecordBtnComponent,
    YoutubePlayerComponent,
    ProgressBarComponent,
    WordExampleBtnComponent,
    ExamplePopupComponent,
    ExampleDispComponent,
    WordHanjaPopupComponent,
    HanjaCharComponent,
    HanjaWordPopupComponent,
    HanjaContentComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    YouTubePlayerModule,
    PipesModule,
    DirectivesModules,
  ],
  exports: [
    BackBtnComponent,
    BoardDetailComponent,
    CommonPopupsComponent,
    DialectDetailComponent,
    DialectItemComponent,
    DialectMapBtnComponent,
    DialectWordPlayBtnComponent,
    FooterComponent,
    HeaderComponent,
    HomonymAllPlayBtnComponent,
    HomonymWordPlayBtnComponent,
    HunContentComponent,
    JasoIndexComponent,
    JasoIndexDialectComponent,
    JasoIndexSeungjoComponent,
    LinkContentComponent,
    LinkExampleComponent,
    OptionItemComponent,
    ProverbDetailComponent,
    SearchBoxComponent,
    SearchBoxDialectComponent,
    SearchBoxSaseungComponent,
    VideoBoxComponent,
    VideoItemComponent,
    VideoTotalItemComponent,
    WordDetailComponent,
    WordDetailHomonymComponent,
    WordDetailProverbComponent,
    WordDispComponent,
    WordHelpBtnComponent,
    WordHelpPopupComponent,
    ExampleHelpBtnComponent,
    ExampleHelpPopupComponent,
    ExampleDetailComponent,
    ExampleListItemComponent,
    WordListItemComponent,
    ExamplePlayBtnComponent,
    WordPlayBtnComponent,
    WordRecordBtnComponent,
    HanjaContentComponent,
    ExampleDispComponent,
    ExampleCatIndexComponent,
  ],
})
export class ComponentsModule { }
